const isOverflowing = element => element.scrollWidth > element.clientWidth;

export default isOverflowing;
